<ng-template #voorwaardenAuto>
    <!-- prettier-ignore -->
    <p>
        Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
        <ins-pdf-link
            [pdfLink]="documentsEnum.ConditionsCarInsurance"
            pdfLinkTitle="Voorwaarden Autoverzekering"
        >
            in onze voorwaarden</ins-pdf-link>.
    </p>
</ng-template>

<ng-container *ngIf="coverageId === coverageIdEnum.SchadeverzekeringInzittenden">
    <wuc-tabset tabsetStyle="secondary">
        <wuc-tabset-item name="Wel verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>
                        De persoonlijke schade van de inzittenden, ook de bestuurder, van uw auto is verzekerd bij een
                        verkeersongeval wanneer zij:
                    </p>
                    <wuc-list icon="dot">
                        <wuc-list-item>In de auto zijn</wuc-list-item>
                        <wuc-list-item>In of uit de auto stappen</wuc-list-item>
                        <wuc-list-item>Onderweg aan uw auto werken of helpen om de auto te repareren</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>
                        Ook hun spullen zijn dan verzekerd. Het maakt niet uit of de bestuurder schuldig is aan het
                        verkeersongeval.
                    </p>
                    <div class="h3">Waar bent u verzekerd?</div>
                    <p>
                        De inzittenden van uw auto zijn verzekerd in heel Europa, de landen die grenzen aan de
                        Middellandse Zee en de niet-doorgestreepte landen op uw groene kaart.
                    </p>
                    <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Niet verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>In bepaalde situaties is schade aan inzittenden niet verzekerd.</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>
                            Schade door een verkeersongeval doordat de bestuurder drugs, alcohol of medicijnen heeft
                            gebruikt. Behalve als de middelen van een dokter gebruikt moesten worden en de
                            gebruiksaanwijzing is gevolgd
                        </wuc-list-item>
                        <wuc-list-item>Schade aan personen die geen passagiersstoel gebruikten</wuc-list-item>
                        <wuc-list-item>
                            Schade aan personen die de auto niet mochten besturen en/of meereden met die persoon
                        </wuc-list-item>
                        <wuc-list-item>Schade aan geld, creditcards of andere waardepapieren</wuc-list-item>
                    </wuc-list>
                </div>
                <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Verzekerde bedragen">
            <wuc-rack gridGap="medium">
                <div>
                    <p>Wij vergoeden maximaal €&nbsp;1.500.000 per schadegeval.</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>
                            Is de totale schade hoger? Dan verdelen wij het bedrag naar rato, zodat de persoon met de
                            meeste schade ook het hoogste bedrag krijgt
                        </wuc-list-item>
                        <wuc-list-item>
                            Draagt een inzittende geen gordel? Dan verlagen wij het bedrag met 25%
                        </wuc-list-item>
                        <wuc-list-item>
                            Wij vergoeden geen juridische hulp of bijstand. Dat is wel verzekerd met onze Ongeval &
                            Verkeer dekking van onze Rechtsbijstandsverzekering
                        </wuc-list-item>
                    </wuc-list>
                </div>
                <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Eigen Risico">
            <p class="no-brake">€&nbsp;0</p>
            <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
        </wuc-tabset-item>
    </wuc-tabset>
</ng-container>

<ng-container *ngIf="coverageId === coverageIdEnum.Pechhulp">
    <wuc-tabset tabsetStyle="secondary">
        <wuc-tabset-item name="Wel verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>
                        De hulp als u pech heeft door een storing aan uw auto of aanhanger als deze achter uw auto is
                        vastgemaakt. Ook in de volgende situaties komen wij u helpen:
                    </p>
                    <wuc-list icon="dot">
                        <wuc-list-item>Bij een lekke band</wuc-list-item>
                        <wuc-list-item>Als u in de modder of sneeuw strandt</wuc-list-item>
                        <wuc-list-item>De autosleutels verloren zijn</wuc-list-item>
                        <wuc-list-item>De auto een lege accu heeft</wuc-list-item>
                        <wuc-list-item>De verkeerde brandstof getankt is</wuc-list-item>
                        <wuc-list-item>De auto heeft geen brandstof meer</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <div class="h3">Hoe helpen wij u?</div>
                    <wuc-list icon="dot">
                        <wuc-list-item>
                            Reparatie op de plek waar de auto stilstaat, als dit binnen een uur gerepareerd kan zijn,
                            anders brengen wij uw auto naar een autobedrijf in de buurt of een adres in Nederland naar
                            keuze. De passagiers en bagage mogen mee
                        </wuc-list-item>
                        <wuc-list-item>
                            In het buitenland regelen wij vervangend vervoer als de reparatie langer dan 48 uur duurt
                        </wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <div class="h3">Waar bent u verzekerd?</div>
                    <p>
                        U bent verzekerd voor hulp in Nederland, ook in uw woonplaats. Heeft u de Europa dekking
                        afgesloten? Dan bent u ook verzekerd voor hulp in de Europese landen die op uw Groene Kaart
                        staan.
                    </p>
                    <div class="h3">Wie is er verzekerd?</div>
                    <p>
                        Degene die de verzekering afsluit, de regelmatig bestuurder en de bestuurder (als hij/zij met uw
                        toestemming erin rijdt).
                    </p>
                    <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Niet verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>Wij vergoeden geen kosten als:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>
                            U kosten maakt waar Eurocross Alarmcentrale geen toestemming heeft gegeven
                        </wuc-list-item>
                        <wuc-list-item>Als uw auto niet goed onderhouden is</wuc-list-item>
                        <wuc-list-item>Uw auto te zwaar beladen is</wuc-list-item>
                        <wuc-list-item>
                            De bestuurder drugs, alcohol of medicijnen heeft gebruikt en daardoor pech kreeg. Behalve
                            als de middelen van een dokter gebruikt moesten worden en de gebruiksaanwijzing is gevolgd
                        </wuc-list-item>
                        <wuc-list-item>
                            Als u uw auto verhuurd of personen vervoert voor geld. Bij carpoolen krijgt u wel hulp
                        </wuc-list-item>
                        <wuc-list-item>Schade door bergen, takelen of slepen</wuc-list-item>
                        <wuc-list-item>
                            Als u niets doet om pech te voorkomen. En u had kunnen weten dat daardoor de kans op pech
                            groot is
                        </wuc-list-item>
                    </wuc-list>
                </div>
                <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Eigen Risico">
            <p class="no-brake">€&nbsp;0</p>
            <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
        </wuc-tabset-item>
    </wuc-tabset>
</ng-container>
